export const etherscanTokenUrl = (address, token) => {
    return process.env.REACT_APP_ETHERSCAN_URL + `/token/${address}?a=${token}`
}